// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-header {
  width: calc(100% - 80px);
  border-bottom: 2px solid #9db6be;
  display: flex;
  height: 60px;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 11;
  background: #ffffff;
  top: 0;
}
.site-header.sidebar-open {
  width: calc(100% - 200px);
}
.site-header .header-title {
  padding-top: 10px;
}
.site-header .header-left {
  left: 65px;
  margin: 15px;
  position: absolute;
}
.site-header .header-right {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
}
.site-header .camp-login-title {
  width: auto;
  height: auto;
  flex-grow: 0;
  font-family: "Open Sans";
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.37;
  letter-spacing: normal;
  text-align: center;
  color: #414b4f;
}

.camp-name {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  color: #414b4f;
}

.camp-email-a {
  font-size: 14px;
  font-weight: 400;
  color: #85a3ad;
}

.header-user-profile-name {
  display: inline-block;
  font-size: 14px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: -7px;
}

.header-user-profile-email {
  display: inline-block;
  font-size: 14px;
  max-width: 150px;
  color: #85a3ad;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
}
@media (max-width: 800px) {
  .header-user-profile-email {
    display: none;
  }
}

.header-avatar {
  cursor: pointer;
}

.maintenance-banner {
  background-color: #414b4f;
  border-left: 1px solid white;
  padding: 12px 0px;
  border-radius: 4px;
  max-width: 100%;
  width: 100%;
  text-align: center;
  display: flex;
  margin-top: 56px;
}
.maintenance-banner strong {
  font-weight: 600;
  display: block;
  margin: 0px 0px 0px 0px;
  color: #FFA65D;
  text-align: left;
}
.maintenance-banner p {
  margin: 0;
  font-size: 14px;
  color: white;
}

.banner-text {
  margin-left: 25px;
  margin-top: 10px;
}

.banner-icon img {
  margin: 5px 0px 0px 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Header.scss","webpack://./src/styles/sizes.scss"],"names":[],"mappings":"AAGA;EACE,wBAAA;EACA,gCAAA;EACA,aAAA;EACA,YCPc;EDQd,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,MAAA;AAFF;AAIE;EACE,yBAAA;AAFJ;AAKE;EACE,iBAAA;AAHJ;AAME;EACE,UAAA;EACA,YAAA;EACA,kBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;AALJ;AAQE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AANJ;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AATF;;AAYA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AATF;;AAYA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AATF;AAWE;EAVF;IAWI,aAAA;EARF;AACF;;AAWA;EACE,eAAA;AARF;;AAWA;EACE,yBAAA;EACA,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AARF;AAUE;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AARJ;AAWE;EACE,SAAA;EACA,eAAA;EACA,YAAA;AATJ;;AAeA;EACE,iBAAA;EACA,gBAAA;AAZF;;AAgBE;EACE,wBAAA;AAbJ","sourcesContent":["@import '../../styles/colors';\n@import '../../styles/sizes';\n\n.site-header {\n  width: calc(100% - 80px);\n  border-bottom: 2px solid $secondary;\n  display: flex;\n  height: $header-height;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  z-index: 11;\n  background: #ffffff;\n  top: 0;\n\n  &.sidebar-open {\n    width: calc(100% - 200px);\n  }\n  \n  .header-title {\n    padding-top: 10px;\n  }\n\n  .header-left {\n    left: 65px;\n    margin: 15px;\n    position: absolute;\n  }\n\n  .header-right {\n    position: absolute;\n    right: 0;\n    display: flex;\n    align-items: center;\n  }\n\n  .camp-login-title {\n    width: auto;\n    height: auto;\n    flex-grow: 0;\n    font-family: 'Open Sans';\n    font-size: 24px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.37;\n    letter-spacing: normal;\n    text-align: center;\n    color: #414b4f;\n  }\n\n  \n}\n\n.camp-name {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.5;\n  color: #414b4f;\n}\n\n.camp-email-a {\n  font-size: 14px;\n  font-weight: 400;\n  color: #85a3ad;\n}\n\n.header-user-profile-name {\n  display: inline-block;\n  font-size: 14px;\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-bottom: -7px;\n}\n\n.header-user-profile-email {\n  display: inline-block;\n  font-size: 14px;\n  max-width: 150px;\n  color: #85a3ad;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 400;\n\n  @media (max-width: 800px) {\n    display: none;\n  }\n}\n\n.header-avatar {\n  cursor: pointer;\n}\n\n.maintenance-banner {\n  background-color: #414b4f;\n  border-left: 1px solid #ffff;\n  padding: 12px 0px;\n  border-radius: 4px;\n  max-width: 100%;\n  width: 100%;\n  text-align: center;\n  display: flex;\n  margin-top: 56px;\n\n  strong {\n    font-weight: 600;\n    display: block;\n    margin: 0px 0px 0px 0px;\n    color: #FFA65D;\n    text-align: left;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    color: #ffff;\n  }\n}\n\n// Ensure the header layout accommodates the banner\n\n.banner-text {\n  margin-left: 25px;\n  margin-top: 10px;\n}\n\n.banner-icon  {\n  img {\n    margin: 5px 0px 0px 10px;\n  }\n  \n}\n","$header-height: 60px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
